import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries.missingBins;

export const MissingBinsColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    return <RedoTableTextCell text={row.hasMissingBins ? "true" : "false"} />;
  },
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.CENTER,
  sort: catalogEntry.sortDirection,
};
